import Vue from "vue";
import Vuex from "vuex";
import {isEmpty, logger} from "../../plagins/utils";
import {CommandsExternal, CommandsInner, Direction, Kt, KtSetting, Order, Record, Settings} from "../interfaces";
import {changeLanguage} from "../../plagins/translate";
// import {User} from "../interfaces";
// import $ from 'jquery';

Vue.use(Vuex);


// export interface Profile {
//     name: string;
//     login: string;
//     email: string;
// }

export interface Paginator {
    limit: number;
    offset: number;
}

export interface Pagination {
    page: number;
    length: number;
}

export interface Fields {
    dist: string;
}

export interface FilterItem {
    kt_setting: KtSetting;
    item: string;
}

export interface FilterItems {
    kt_setting: KtSetting;
    items: FilterItem[];
    value: FilterItem;
}

export interface Styles {
    background_color: string;
    background_color_accent_1:string;
    background_color_accent_2:string;
    color:string;
    accent:string;
}

export interface RemoteData {
    host: string;
    port: number;
    debug: boolean;
    event: string;
    lang: string;
    title: string;
    certificate_templates_dict: { [id: string]: number };
    styles: Styles;
}

export interface State {
    settings: Settings;

    records: Record[];

    filters: Kt[];

    loading: boolean;

    filter_items: FilterItems[];

    search: string;

    show_search: boolean;

    fields: Fields;

    paginator: Paginator;

    pagination: Pagination;

    list_for_sort: KtSetting[];
    item_for_sort: KtSetting | any;

    kt_settings_by_name: { [id: string]: KtSetting };
    remote_data: RemoteData;

}


const REMOTE_DATA: RemoteData = window.json_context;
const INTERVAL_SOCKET_CHECK = 10 * 1000; //ms
const SOCKET_PROTOCOL = location.protocol === 'https:' ? 'wss' : 'ws'
const SOCKET_URL = `${SOCKET_PROTOCOL}://${REMOTE_DATA.host}/timing-lite/`

changeLanguage(REMOTE_DATA.lang);

//INITIALIZATION SOCKET
let ws = new WebSocket(SOCKET_URL);
ws.onmessage = function (event) {
    store.commit('update', JSON.parse(event.data));
};

//RECONNECT SOCKET
function socket_check() {
    if (!ws || ws.readyState === 3) {
        ws = new WebSocket(SOCKET_URL);
        ws.onmessage = function (event) {
            store.commit('update', JSON.parse(event.data));
        };
    }
}

setInterval(socket_check, INTERVAL_SOCKET_CHECK);//10 sec.


class MainWorker {

    ws_commands: { [id: string]: (request: any) => void } = {};


    constructor() {
        // store.commit('set_title', store.state.remote_data.title);

        this.initCallbackFunctions();

    }

    // getKtTitle(kt: Kt) {
    //     return store.state.settings.columns[kt.id].title;
    // }


    getFilters() {
        let filters: Kt[] = [];

        if (!isEmpty(store.state.fields.dist) && isEmpty(store.state.search)) {
            filters.push({
                id: store.state.kt_settings_by_name.dist.id,
                value: store.state.fields.dist,
            })
        }

        for (let i = 0; i < store.state.filter_items.length; i++) {

            // @ts-ignore
            if (!isEmpty(store.state.filter_items[i].value)) {
                filters.push({
                    // @ts-ignore
                    id: store.state.filter_items[i].kt_setting.id,
                    // @ts-ignore
                    value: store.state.filter_items[i].value.item,
                });
                // @ts-ignore
                // loggerr('filter : ', store.state.filter_items[i].kt_setting.title, store.state.filter_items[i].value.item);
            }
        }
        return filters;
    }

    subscribeOnUpdateData(request: any): void {
        store.commit('set_loading', true);
        let message: { command: string, event: string, data: any } = {
            event: store.state.remote_data.event,
            command: CommandsExternal.SUBSCRIBE_ON_UPDATE_DATA,
            data: {
                offset: store.state.paginator.offset,
                limit: store.state.paginator.limit,
                filters: this.getFilters(),
                search: store.state.search,
                order: store.state.settings.table.order,
            }
        };
        // loggerr(message);

        ws.send(JSON.stringify(message));
        // this.loading = true;
    }


    getSettings(request: any): void {

        let message: { command: string, event: string, lang: string } = {
            event: store.state.remote_data.event,
            command: CommandsExternal.GET_SETTINGS,
            lang: store.state.remote_data.lang
        };
        let json_message = JSON.stringify(message);

        // loggerr('getSettings: ',message);

        ws.send(json_message);
        // this.loading = true;
    }

    init_list_for_sort() {
        let list_for_sort: KtSetting[] = [];

        for (let i = 0; i < store.state.settings.columns.length; i++) {
            if (!isEmpty(store.state.settings.columns[i].title) && isEmpty(store.state.settings.columns[i].drop_down)) {
                list_for_sort.push(store.state.settings.columns[i])
            }
        }
        store.commit('set_list_for_sort', list_for_sort);
    }


    init_list_for_filter() {
        let filter_list: any[] = [];
        for (let i = 0; i < store.state.settings.columns.length; i++) {
            let kt_setting: KtSetting | any = store.state.settings.columns[i];

            if (!isEmpty(kt_setting.drop_down) && kt_setting.name !== 'dist') {
                let items: {}[] = [];

                for (let j = 0; j < kt_setting.drop_down.length; j++) {
                    items.push({
                        kt_setting: kt_setting,
                        item: kt_setting.drop_down[j]
                    });
                }
                filter_list.push({
                    kt_setting: store.state.settings.columns[i],
                    items: items,
                })
            }
        }
        store.commit('set_filter_items', filter_list);
    }

    callbackGetSettings(request: any): void {
        if (request.data) {

            store.commit('set_settings', request.data.data);

            let kt_settings_by_name: { [id: string]: KtSetting } = {};

            for (let i = 0; i < store.state.settings.columns.length; i++) {
                let kt_setting: KtSetting = store.state.settings.columns[i];
                if (!isEmpty(kt_setting.name)) {
                    kt_settings_by_name[kt_setting.name] = kt_setting;
                }
            }

            store.commit('set_kt_settings_by_name', kt_settings_by_name);

            store.commit(
                'set_pagination', {
                    page: store.state.pagination.page,
                    length: Math.ceil(store.state.settings.table.number_records / store.state.paginator.limit)
                });

            if (store.state.kt_settings_by_name.dist && store.state.kt_settings_by_name.dist.drop_down && store.state.kt_settings_by_name.dist.drop_down.length > 0) {
                store.commit('set_field_dist', store.state.kt_settings_by_name.dist.drop_down[0])

            } else {
                store.commit('set_field_dist', '')
            }

            store.commit('init_list_for_sort');
            store.commit('init_list_for_filter');
            store.commit('subscribe_on_update_data');
        }
    }


    callbackUpdateData(request: any): void {
        if (request.data) {
            // logger(request.data.records);

            let bib_record: { [id: number]: Record } = {};

            for (let i = 0; i < store.state.records.length; i++) {
                // @ts-ignore
                bib_record[store.state.records[i].bib] = store.state.records[i];
            }

            let records: Record[] = [];
            for (let i = 0; i < request.data.records.length; i++) {

                let index = i + store.state.paginator.offset + 1;
                let bib = 0;
                let name = '';
                let dist = '';
                let gun = '';
                let start = '';
                let guntime = '';
                let chiptime = '';
                let result = '';
                let finish = '';
                let is_valid = 0;
                let last_kt: Kt = {
                    id: 0,
                    value: null
                };

                let kts: Kt[] = [];

                for (let j = 0; j < request.data.records[i].length; j++) {

                    if (store.state.settings.columns[j].name === 'bib') {
                        bib = request.data.records[i][j].value;
                        continue;
                    }
                    if (store.state.settings.columns[j].name === 'gun') {
                        gun = request.data.records[i][j].value;
                        continue;
                    }
                    if (store.state.settings.columns[j].name === 'start') {
                        start = request.data.records[i][j].value;
                        continue;
                    }
                    if (store.state.settings.columns[j].name === 'guntime') {
                        guntime = request.data.records[i][j].value;
                        continue;
                    }
                    if (store.state.settings.columns[j].name === 'finish') {
                        finish = request.data.records[i][j].value;
                        continue;
                    }
                    if (store.state.settings.columns[j].name === 'is_valid') {
                        is_valid = request.data.records[i][j].value;
                        continue;
                    }
                    if (store.state.settings.columns[j].name === 'chiptime') {
                        chiptime = request.data.records[i][j].value;
                        continue;
                    }
                    if (store.state.settings.columns[j].name === 'result') {
                        result = request.data.records[i][j].value;
                        continue;
                    }
                    if (store.state.settings.columns[j].name === 'last_name') {
                        if (name.length > 0) name += ' ';
                        name += request.data.records[i][j].value;
                        continue;
                    }
                    if (store.state.settings.columns[j].name === 'first_name') {
                        if (name.length > 0) name += ' ';
                        name += request.data.records[i][j].value;
                        continue;
                    }
                    if (store.state.settings.columns[j].name === 'dist') {
                        dist = request.data.records[i][j].value;
                    }
                    if ((store.state.settings.columns[j].name === 'dist') && isEmpty(store.state.search)) {
                        // JUST REPLACE
                        continue;
                    }
                    kts.push(request.data.records[i][j])

                }

                let selected: boolean = false;

                if (bib_record[bib]) {
                    // @ts-ignore
                    selected = bib_record[bib].selected;
                }


                let record: Record = {
                    index: index,
                    selected: selected,
                    bib: bib,
                    dist:dist,
                    name: name,
                    gun: gun,
                    start: start,
                    guntime: guntime,
                    chiptime: chiptime,
                    finish: finish,
                    is_valid: is_valid,
                    result: result,
                    last_kt: last_kt,
                    kts: kts
                };
                records.push(record)
            }
            // logger(records);
            store.commit('set_records', records);
            store.commit('set_number_records', request.data.number_records);

            store.commit(
                'set_pagination', {
                    page: store.state.pagination.page,
                    length: Math.ceil(store.state.settings.table.number_records / store.state.paginator.limit)
                });
            // Vue.set(store.state.pagination, "length", Math.ceil(store.state.settings.table.number_records / store.state.paginator.limit));

            // this.loading = false;
            store.commit('set_loading', false);
        }
    }

    applyFilter() {
        store.commit('set_paginator', {
            offset: 0,
            limit: store.state.paginator.limit
        });
        store.commit('set_pagination', {
            page: 1,
            length: store.state.pagination.length
        });
        store.commit('subscribe_on_update_data');
        store.commit('set_drawer_right_toolbar', false);
    }


    update(request: any) {
        if (!this.ws_commands) return;

        if (!request.command || !this.ws_commands[request.command]) {
            return
        }
        this.ws_commands[request.command](request);
    }


    initCallbackFunctions() {
        this.ws_commands[CommandsInner.UPDATE_DATA] = this.callbackUpdateData;
        this.ws_commands[CommandsInner.SUBSCRIBE_ON_UPDATE_DATA] = this.subscribeOnUpdateData;
        this.ws_commands[CommandsInner.GET_SETTINGS] = this.getSettings;
        this.ws_commands[CommandsInner.CALLBACK_GET_SETTINGS] = this.callbackGetSettings;

        this.ws_commands[CommandsInner.UPDATE_SETTINGS] = this.callbackUpdateData;
    }

}

let main_worker: MainWorker = new MainWorker();

let store = new Vuex.Store({
    state: {
        loading: true,
        drawer_right_toolbar: false,
        title: "TIMING LITE",
        settings: {
            table: {
                hash: 0,
                is_active: true,
                number_records: 0,
                order: {
                    column_id: 0,
                    direction: Direction.asc
                },
            },
            columns: [
                {
                    id: 0,
                    name: '',
                    title: '',
                    is_show: true,
                    is_time: false,
                    drop_down: []
                }
            ]
        },
        records: [],

        filters: [],
        filter_items: [],


        search: '',
        show_search: false,
        fields: {
            dist: '',
        },
        paginator: {
            limit: 10,
            offset: 0,
        },
        pagination: {
            page: 1,
            length: 1
        },
        list_for_sort: [],
        item_for_sort: {},
        kt_settings_by_name: {
            'dist': {
                id: 0,
                name: '',
                title: '',
                is_show: true,
                is_time: false,
                drop_down: []
            }
        },
        remote_data: REMOTE_DATA
    },
    mutations: {

        change_drawer_right_toolbar(state, response) {
            let drawer: boolean = !state.drawer_right_toolbar;
            Vue.set(state, 'drawer_right_toolbar', drawer);

        },
        set_drawer_right_toolbar(state, is_open: boolean) {
            Vue.set(state, 'drawer_right_toolbar', is_open);
        },

        set_loading(state, loading: boolean) {
            Vue.set(state, 'loading', loading);
        },


        // set_access_token(state, response) {
        //     logger("set_access_token");
        //
        //     sessionStorage.setItem("access_token", response.data.access_token);
        //     sessionStorage.setItem("profile", JSON.stringify(response.data.profile));
        //
        //     Vue.set(state, 'profile', response.data.profile);
        //     Vue.set(state, 'access_token', response.data.access_token);
        //     Vue.set(state, 'is_auth', true);
        //
        // },
        set_user(state, users: any) {
            // logger("user");
            Vue.set(state, 'user', users[0]);
            // sessionStorage.setItem("user", JSON.stringify(user));
        },
        set_title(state, title: string) {
            // logger("title");
            Vue.set(state, 'title', title);
        },
        set_settings(state, settings: Settings) {
            // logger("settings");
            Vue.set(state, 'settings', settings);
            Vue.set(state, 'item_for_sort', settings.columns[settings.table.order.column_id]);
            Vue.set(state, 'direction_for_sort', settings.table.order.direction);
        },
        set_number_records(state, number_records: number) {
            // loggerr("number_records");
            Vue.set(state.settings.table, 'number_records', number_records);

        },
        set_filter_items(state, filter_items: FilterItems[]) {
            // loggerr("set_filter_items");
            Vue.set(state, 'filter_items', filter_items);

        },
        set_field_dist(state, field: string) {
            // loggerr("field_dist");
            Vue.set(state.fields, 'dist', field);
        },
        set_paginator(state, paginator: Paginator) {
            // loggerr("paginator");
            Vue.set(state, 'paginator', paginator);
        },
        set_pagination(state, pagination: Pagination) {
            // loggerr("pagination");
            Vue.set(state, 'pagination', pagination);
        },
        set_list_for_sort(state, list_for_sort: KtSetting[]) {
            // loggerr("list_for_sort");
            Vue.set(state, 'list_for_sort', list_for_sort);
        },
        set_sort_by(state: State, kt: KtSetting) {
            // loggerr("sort_by: ", kt.title);
            Vue.set(state.settings.table.order, 'column_id', kt.id);
        },
        set_direction_for_sort(state: State, direction: Direction) {
            // loggerr("direction_for_sort: ", direction);
            Vue.set(state.settings.table.order, 'direction', direction);
        },
        set_kt_settings_by_name(state: State, kt_settings_by_name: { [id: string]: KtSetting }) {
            // loggerr("kt_settings_by_name: ", kt_settings_by_name);
            Vue.set(state, 'kt_settings_by_name', kt_settings_by_name);
        },


        set_records(state: State, records: Record[]) {
            // loggerr("records: ", records);
            Vue.set(state, 'records', records);
        },
        subscribe_on_update_data(state: State) {
            // loggerr("subscribe_on_update_data");
            main_worker.subscribeOnUpdateData(null);
        },
        init_list_for_sort(state: State) {
            // loggerr("init_list_for_sort");
            main_worker.init_list_for_sort();
        },
        init_list_for_filter(state: State) {
            // loggerr("init_list_for_filter");
            main_worker.init_list_for_filter();
        },
        clean_values_in_list_for_filter(state: State) {
            // loggerr("clean_values_in_list_for_filter");
            for (let i = 0; i < state.filter_items.length; i++) {
                Vue.set(state.filter_items[i], 'value', '')
            }
        },
        clean_records_selected(state: State) {
            // loggerr("clean_records_selected");
            for (let i = 0; i < state.records.length; i++) {
                Vue.set(state.records[i], 'selected', false)
            }
        },
        set_paginator_limit(state: State, limit: number) {
            // loggerr("set_paginator_limit: ", limit);
            Vue.set(state.paginator, 'limit', limit);
        },
        set_search(state: State, value: string) {
            // loggerr("set_search: ", value);
            Vue.set(state, 'search', value)
        },
        show_search(state: State, value: boolean) {
            Vue.set(state, 'show_search', value)
        },
        apply_filter(state: State) {
            // loggerr("apply_filter");
            main_worker.applyFilter();
        },
        update(state: State, data: any) {
            logger("update: ", data);
            main_worker.update(data);
        },


        clean_data(state) {
            // loggerr("clean_data");
            // sessionStorage.removeItem("access_token");
            // sessionStorage.removeItem("access_token");
            // Vue.set(state, 'access_token', '');
            // Vue.set(state, 'is_auth', false);
            Vue.set(state, 'user', null);
            Vue.set(state, 'title', "TIMING LITE");
        },


        load_data(state) {
            // logger("load_data");
            // let access_token: string | null = sessionStorage.getItem("access_token");
            // if (!isEmpty(access_token)) {

            // let str_user: string | null = sessionStorage.getItem("user");
            //
            // let user: User = JSON.parse(str_user === null ? 'null' : str_user);
            //
            // Vue.set(state, 'user', user);


            // $.get('', {
            //          "login": this.loginForm.login,
            //          "password": this.loginForm.password,
            //
            //  }).done((response) => {
            //      logger(response);
            //      store.commit("set_access_token", response.access_token);
            //      this.$router.push({name: "admin"});
            //
            //  }).fail((data) => {
            //      if (data.status === 404) {
            //          this.$alert('Логин или пароль не верен!', 'Ошибка', {
            //              confirmButtonText: 'OK',
            //              type: "error"
            //          });
            //          return;
            //      }
            //      logger("ERROR", data)
            //  });

            return;
            // }

        }
    },
    actions: {
        // increment(context) {
        //     logger("increment, actions");
        //     context.commit('increment');
        // }
    }
});
store.commit("load_data");
export default store;



